import licensingService from '../../../core/services/licensingService';
import { isQawaemDirectAccess } from './isQawaemDirectAccess';

const DIRECT_LICENSE_KEY = 'QAWAEM-DIRECT';

export function ensureQawaemDirectAccessSession() {
  if (!isQawaemDirectAccess()) return;

  const existing = licensingService.getSavedLicense();
  if (!existing || existing.key !== DIRECT_LICENSE_KEY) {
    licensingService.saveLicense({
      key: DIRECT_LICENSE_KEY,
      valid: true,
      appType: 'ALL',
      keyType: 'ALL',
      licenseMode: 'OFFLINE',
      activatedAt: new Date().toISOString(),
      lastChecked: new Date().toISOString(),
    });
  }

  localStorage.setItem('qawaem_product_key_validated', 'true');
  localStorage.setItem('qawaem_license_type', 'PREMIUM');
  localStorage.setItem('qawaem_setup_completed', 'true');

  const guestUser = {
    username: 'مستخدم',
    role: 'admin',
    id: 'qawaem-guest',
    loginTime: new Date().toISOString(),
  };
  localStorage.setItem('qawaem_user', JSON.stringify(guestUser));

  try {
    const featureService = require('../../../core/services/featureService').default;
    if (featureService.clearCache) {
      featureService.clearCache();
    }
  } catch {
    /* noop */
  }
}

export default ensureQawaemDirectAccessSession;
